import axios, { AxiosError } from 'axios';
import { Api } from '../../axios-config';

interface faltas {
  nome: string;
  faltas: number; 
  dsr: number;
}

export interface IFaltaCei {
  idcei: string;
  numero: string;
  nome: string;
  faltas: faltas[];
}

export interface IAniversariantes {
  nome: string; 
  aniversario: string;
}

export interface IFuncionariosPorFazenda {
  nome: string; 
  funcao : string;      
}

interface dados {
  cei: IFaltaCei;
  faltas: faltas [];  
}

interface IPkkolha {
  nome: string;
  cpf: string;
  vencimentos: number;
  descontos: number;
}

export interface IRAlimentacao {
  nome: string;
  cpf: string;
  almoco: number;
  janta: number; 
  cafe: number;
  total: number;
}

export interface IRFerias{
  nome: string;
  cpf: string;
  datainicial: Date; 
  datafinal: Date;
  periodo: string;
  valorinss: number;
}

export interface IRFuncao {
  nome: string;
  funcao: string;
  cargo: string;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const RelatorioAniversariantes = async (mes = ''): Promise<IAniversariantes[] | Error> => {
  try {
    const urlRelativa = `/aniversariantes?mes=${mes}`;
  
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RelatorioFuncionariosporFazenda = async (fazenda= ''): Promise<IFuncionariosPorFazenda[] | Error> => {
  try {
    const urlRelativa = `/funcionariosfazenda?fazenda=${fazenda}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RelatorioFaltaPorCei = async (periodo = ''): Promise<dados[] | Error> => {
  try {
    const urlRelativa = `/faltasporcei?periodo=${periodo}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const ExportFolhaExcel = async (periodo = ''): Promise<dados[] | Error> => {
  try {
    const urlRelativa = `/exportfolha?periodo=${periodo}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const ExportExcelSalarios = async (): Promise<dados[] | Error> => {
  try {
    const urlRelativa = '/exportsalarios';
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const pkkolha = async (periodo = '', fazenda = ''): Promise<IPkkolha[] | Error> => {
  try {
    const urlRelativa = `/pkkolha?periodo=${periodo}&fazenda=${fazenda}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RAlimentacao = async (periodo = '', fazenda = ''): Promise<IRAlimentacao[] | Error> => {
  try {
    const urlRelativa = `/ralimentacao?periodo=${periodo}&fazenda=${fazenda}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RFuncao = async (idfazenda = '', cargo = ''): Promise<IRFuncao[] | Error> => {
  try {
    const urlRelativa = `/rfuncao?idfazenda=${idfazenda}&cargo=${cargo}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const ferias = async (periodo = ''): Promise<IRFerias[] | Error> => {
  try {
    const urlRelativa = `/relatorioferias?periodo=${periodo}`;
    
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const RelatorioService = {
  RelatorioAniversariantes,
  RelatorioFuncionariosporFazenda,
  RelatorioFaltaPorCei,
  ExportFolhaExcel,
  pkkolha,
  RAlimentacao,
  ferias,
  ExportExcelSalarios,
  RFuncao,
};


   